export default {
    answer: '정답',
    explanation: '해설',
};
